/**
 *
 * ActiveTag
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import CircleIcon from 'assets/v2/CircleIcon';
import { COLORS } from 'theme';

import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.kinetikBlue};
    background: ${COLORS.kinetikBlueTransparent};
    border-color: ${COLORS.kinetikBlue};

    &&& .MuiChip-icon path {
      fill: ${COLORS.kinetikBlue};
    }
  }
`;

const ActiveTag = (props) => (
  <StyledTag label="Update" icon={<CircleIcon />} {...props} />
);

export default memo(ActiveTag);
